import { css } from 'styled-components';
import { BreakpointQueryName } from '../../theme';
import { SpacingName } from '../../theme/constants';
import { TypographyName } from '../../theme/typography';
import { getTypography, getSpacing, rgba } from '../../theme/utils';
export const SYMBOL_SIZE = 18;
export const base = _ref => {
  let {
    theme,
    $hidden
  } = _ref;
  return css(["position:relative;display:flex;align-items:center;", " ", ""], getTypography(theme, TypographyName.BODY), $hidden && `
    display: none;
  `);
};
export const input = _ref2 => {
  let {
    theme,
    disabled,
    $error,
    $hasIcon,
    $prefix
  } = _ref2;
  return css(["", " ", " color:", ";box-sizing:border-box;width:100%;border:1px solid ", ";height:3.125rem;line-height:3.125rem;border-radius:", ";flex-grow:1;outline:0;appearance:none;-moz-appearance:none;-webkit-appearance:none;padding-right:", ";", "{padding-right:", ";}&::placeholder{color:", ";}&:focus{box-shadow:0px 0 4px ", ";border:1px solid ", ";}", " ", ""], getTypography(theme, TypographyName.BODY), getSpacing.paddingLeft(theme, SpacingName.SMALLER), theme.palettes.neutrals.darkest, theme.palettes.neutrals.medium, $prefix ? '0 .3rem .3rem 0' : '.3rem', $hasIcon ? `calc((${theme.spaceUnits.mobile.SMALLER} * 2) + ${SYMBOL_SIZE}px)` : theme.spaceUnits.mobile.SMALLER, theme.breakpoints.up(BreakpointQueryName.LG), $hasIcon ? `calc((${theme.spaceUnits.desktop.SMALLER} * 2) + ${SYMBOL_SIZE}px)` : theme.spaceUnits.desktop.SMALLER, theme.palettes.neutrals.medium, rgba(theme.palettes.neutrals.darkest, 0.3), theme.palettes.neutrals.medium, disabled && `
    background-color: ${rgba(theme.palettes.status.disabled, 0.3)};
    border: 1px solid ${theme.palettes.neutrals.lighter};
    color: ${theme.palettes.neutrals.medium};
    user-select: none;

    &::placeholder {
      color: ${theme.palettes.neutrals.light};
    }
  `, $error && `
    border-color: ${theme.palettes.status.alert};
  `);
};
export const overlay = _ref3 => {
  let {
    theme
  } = _ref3;
  return css(["position:absolute;top:0;right:0;bottom:0;", " background-color:transparent;display:flex;align-items:center;color:", ";z-index:1;"], getSpacing.paddingRight(theme, SpacingName.SMALLER), theme.palettes.neutrals.medium);
};
export const icon = _ref4 => {
  let {
    theme,
    $error,
    $valid,
    $isVisible,
    disabled,
    $isValidationIcon,
    $filled
  } = _ref4;
  return css(["", " color:", ";opacity:0;outline:0;border:0;", " ", " ", " ", " ", " ", ""], overlay({
    theme
  }), $filled ? theme.palettes.neutrals.dark : theme.palettes.neutrals.medium, $valid && `
    color: ${theme.palettes.status.success};
  `, $error && `
    color: ${theme.palettes.status.alert};
  `, !disabled && !$isValidationIcon && `
    cursor: pointer;

    &:hover {
      color: ${theme.palettes.neutrals.darkest};
    }
  `, disabled && `
    color: ${theme.palettes.neutrals.light};
  `, $isVisible && `
    opacity: 1;
  `, $isValidationIcon && `
    z-index: 2;
  `);
};
export const prefix = _ref5 => {
  let {
    theme,
    $error,
    $value,
    $disabled
  } = _ref5;
  return css(["", " border-radius:.3rem 0 0 .3rem;height:3.125rem;line-height:3.125rem;color:", ";background:", ";border:1px solid ", ";border-right:0;display:flex;align-items:center;", " ", " ", ""], getSpacing.padding(theme, [0, SpacingName.SMALLER]), theme.palettes.neutrals.dark, theme.palettes.neutrals.lighter, theme.palettes.neutrals.medium, $value && `
    color: ${theme.palettes.brand.primary};
  `, $error && `
    border-color: ${theme.palettes.status.alert};
    color: ${theme.palettes.status.alert};
    background-color: ${theme.palettes.status.alertLighter};
  `, $disabled && `
    border: 1px solid ${theme.palettes.neutrals.lighter};
    background-color: ${theme.palettes.neutrals.lighter};
    color: ${theme.palettes.neutrals.medium};
    user-select: none;
  `);
};
//# sourceMappingURL=Input.style.js.map